import { createAsyncThunk } from '@reduxjs/toolkit';
import { TransactionServices } from 'Services/axios/Transaction.Service';
import { checkFilter } from 'Features/Common/CommonUtils';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTransactions = createAsyncThunk(
    'Transactions/fetchTransactions',
    async (filters) => {
        try {
            const response = await TransactionServices.getAll(filters);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const exportTransactions = createAsyncThunk(
    'Transactions/exportTransactions',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            delete newFilter.page;
            const response = await TransactionServices.export(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const setOrderStatus = createAsyncThunk(
    'Transactions/setOrderStatus',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('status', data.status);
            let response;
            response = await TransactionServices.setOrderStatus(data.id, formData);
            toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return response.data.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);